import {useContext, useEffect, useRef, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {BaSeButton, BaSeHeading6, BaSeIcon, BaSeUserApps} from "@base/react";
import {MenuItems, ProfileItems} from "../../../mocks/menu";
import logo from "../../../assets/images/logo-planejadora-vertical.png";
import logoInline from "../../../assets/images/logo-planejadora.png";
import Acronyms from "../../acronyms";
import {AppContext} from "../../../context/app";
import ModalDefault from "../../modals/modal-default";
import {eventTag, getCurrentCNPJ, getCurrentCompany, truncateText,} from "../../../services/utils";
import ApiAuth, {redirectToKeycloak} from "../../../services/auth";
import ApiPlannings from "../../../services/planning";
import FloatingMenu from "../../floating-menu";
import Notifications from "../../notifications";
import {clearCompaniesCache, setCompaniesCache} from "../../../services/companiesCache";
import "./index.scss";

const event = {
  name: "click-button",
  category: "header",
  action: "click",
}
const apiPlannings = ApiPlannings();

export default function Header({ account }) {
  const { pathname } = useLocation();
  const userCpf = account?.cpf;
  const hasAccount = Boolean(account);
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [hasConsultingAccess, setHasConsultingAccess] = useState(false);
  const [menuOpen, setMenuOpen] = useState({
    menu: false,
    profile: false,
  });
  const [shouldRender, setShouldRender] = useState({
    menu: false,
  });
  const { companies, setCompanies } = useContext(AppContext);
  const shouldRefreshCompaniesAfterCpe = useRef(false);
  const [modalOpen, setModalOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  function slugify(text) {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  const toggleSideMenu = (value = !menuOpen.menu) => {
    setMenuOpen((prev) => ({
      ...prev,
      menu: value,
    }));

    if (value) {
      setShouldRender((prev) => ({
        ...prev,
        menu: value,
      }));
      document.body.style.overflow = "hidden";
    } else {
      setTimeout(() => {
        setShouldRender((prev) => ({
          ...prev,
          menu: value,
        }));
        document.body.style.overflow = "";
      }, 255);
    }
  };
  const toggleMenuProfile = (value = !menuOpen.profile) => {
    setMenuOpen((prev) => ({
      ...prev,
      profile: value,
    }));
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    eventTag(event?.name, event?.category, event?.action, "Fechar modal")
  };
  const handleLinkClick = (e, id) => {
    toggleSideMenu(false);

    if (id === 3) {
      e.preventDefault();
      clickGuideTour();
    }
  };
  const logout = () => {
    ApiAuth().logout()
  };
  const refreshCompaniesAfterCpe = () => {
    if (!shouldRefreshCompaniesAfterCpe.current) return
    if (document.visibilityState === "hidden") return

    shouldRefreshCompaniesAfterCpe.current = false
    const company = getCurrentCNPJ(companies) || null

    ApiAuth()
      .getCompanies()
      .then((res) => {
        const { data } = res
        const newData = data.company_list.map((item) => ({
          ...item,
          isActive: company === item.cnpj || !!item.getCurrentCNPJ,
        }))

        setCompaniesCache(newData)
        setCompanies(newData)
      })
      .catch((err) => {
        console.warn(err)
        clearCompaniesCache()
        setCompanies([])
      })
  };
  const clickGuideTour = () => {
    const data = JSON.parse(localStorage.getItem("tutorials")) || {};

    Object.keys(data).forEach((key) => {
      if (data[key].hasOwnProperty("finalizado")) {
        data[key].finalizado = false;
      }

      if (data[key].hasOwnProperty("step")) {
        data[key].step = 0;
      }
    });

    data.isFinished = false;
    localStorage.setItem("hideGuidedTour", "false");
    localStorage.setItem("tutorials", JSON.stringify(data));
    navigate("/inicio");
    window.location.reload();
  };
  useEffect(() => {
    const hiddenMenuRoutes = [
      "/",
      "/planejadora",
      "/como-utilizar",
      "/acesso-negado",
      "/erro-sistema",
    ]

    setShowMenu(!hiddenMenuRoutes.includes(pathname))
  }, [pathname]);

  useEffect(() => {
    window.addEventListener("focus", refreshCompaniesAfterCpe)
    document.addEventListener("visibilitychange", refreshCompaniesAfterCpe)

    return () => {
      window.removeEventListener("focus", refreshCompaniesAfterCpe)
      document.removeEventListener("visibilitychange", refreshCompaniesAfterCpe)
    }

    // eslint-disable-next-line
  }, [companies])

  useEffect(() => {
    let isMounted = true;

    const loadConsultingAccess = async () => {
      if (!hasAccount) {
        setHasConsultingAccess(false);
        return;
      }

      try {
        const { data } = await apiPlannings.hasConsultingAccess();
        if (isMounted) {
          setHasConsultingAccess(Boolean(data));
        }
      } catch (error) {
        if (isMounted) {
          setHasConsultingAccess(false);
        }
      }
    };

    loadConsultingAccess();

    return () => {
      isMounted = false;
    };
  }, [hasAccount, userCpf]);

  const visibleMenuItems = MenuItems.filter(
    (item) => item.path !== "/consultoria" || hasConsultingAccess,
  );

  const TemplateMenuProfile = () => {
    return (
      <nav className="menu-profile">
        <div className="profile">
          <Acronyms avatar={account?.foto} nameUser={account?.name} />
          <div className="info">
            <h5 className="text-ellipsis" title={account?.name}>
              {account?.name}
            </h5>
            <h6 className="text-ellipsis" title={account?.email}>
              {account?.email}
            </h6>
          </div>
          <button
            type="button"
            className="btn-without-style"
            onClick={() => {
              toggleSideMenu(false);
              eventTag(event?.name, event?.category, event?.action, "Fechar")
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
            >
              <path
                d="M4.93996 3.9998L7.80663 1.1398C8.06804 0.878383 8.06804 0.454546 7.80663 0.193131C7.54521 -0.0682834 7.12137 -0.0682834 6.85996 0.193131L3.99996 3.0598L1.13996 0.193131C0.878545 -0.0682834 0.454707 -0.0682834 0.193293 0.193131C-0.0681221 0.454546 -0.0681221 0.878383 0.193293 1.1398L3.05996 3.9998L0.193293 6.8598C0.0670842 6.98498 -0.00390625 7.15537 -0.00390625 7.33313C-0.00390625 7.51089 0.0670842 7.68129 0.193293 7.80646C0.31847 7.93267 0.488868 8.00366 0.666626 8.00366C0.844384 8.00366 1.01478 7.93267 1.13996 7.80646L3.99996 4.9398L6.85996 7.80646C6.98514 7.93267 7.15553 8.00366 7.33329 8.00366C7.51105 8.00366 7.68145 7.93267 7.80663 7.80646C7.93283 7.68129 8.00383 7.51089 8.00383 7.33313C8.00383 7.15537 7.93283 6.98498 7.80663 6.8598L4.93996 3.9998Z"
                fill="#B6BFC8"
              />
            </svg>
          </button>
        </div>
        <ul>
          {ProfileItems.map((item, index) => (
            <li key={index}>
              <a
                href={item.path}
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                  if (item.path.includes(process.env.REACT_APP_CPE)) {
                    clearCompaniesCache()
                    shouldRefreshCompaniesAfterCpe.current = true
                  }
                  eventTag(event?.name, event?.category, event?.action, item.name)
                }}
              >
                {item.name}
              </a>
            </li>
          ))}
          <li>
            <button
              type="button"
              onClick={() => {
                logout();
                eventTag(event?.name, event?.category, event?.action, "Sair")
              }}
              className="btn-without-style"
            >
              Sair
            </button>
          </li>
        </ul>
      </nav>
    );
  };
  const TemplateCompany = () => {
    const company = getCurrentCompany(companies);
    return (
      <div className="company">
        <h3 title={company?.name}>
          {truncateText(company?.name, 23) || "Empresa"}
        </h3>
        <button
          id="profile-driver-js"
          type="button"
          className="link"
          onClick={() => {
            setShowFloatingMenu((prev) => !prev)
            eventTag(event?.name, event?.category, event?.action, "Alterar minha empresa")
          }}
        >
          Alterar minha empresa
        </button>
      </div>
    );
  };
  const Solutions = ({ iconColor = "#ffffff" }) => {
    return (
      <BaSeUserApps
        closeMenuColor="#005eb8"
        description="Conheça os serviços que o Sebrae oferece para apoia o empreendedor brasileiro:"
        iconColor={iconColor}
        menuBackgroundColor="#ffffff"
        menuBorderColor="#f0f6fe"
        solutions={[
          {
            description: 'Busque e simule o serviço financeiro ideal para a sua empresa.',
            link: 'https://calculadora.sebrae.com.br/',
            title: 'Calculadora'
          },
          {
            description: 'Descubra como fazer a sua ideia, ou o seu negócio evoluir.',
            link: 'https://sebrae.com.br/pnbox',
            title: 'PNBOX'
          },
          {
            description: 'Gerencie os gastos, lucro e investimentos da sua empresa.',
            link: 'https://fluxocaixa.sebrae.com.br/',
            title: 'Fluxo de Caixa'
          },
          {
            description: 'Tudo da sua empresa na sua mão, disponível para IoS e Android.',
            link: 'https://sebrae.com.br/subsites/aplicativo-sebrae',
            title: 'App Sebrae'
          },
        ]}
        textColor="#617385"
        title="Serviços"
        titleColor="#005eb8"
      />
    )
  }

  return (
    <header id="header">
      {showFloatingMenu && (
        <FloatingMenu onClose={() => setShowFloatingMenu(false)} />
      )}

      <ModalDefault
        title="Limite Máximo de Planejamentos"
        callBackClose={handleCloseModal}
        show={modalOpen}
      >
        <BaSeHeading6>
          Você atingiu o limite máximo de <strong>120 planejamentos</strong>{" "}
          para o ano de {currentYear}.{" "}
        </BaSeHeading6>
        <br />
        <BaSeHeading6>
          Para adicionar novos planejamentos, por favor, exclua um planejamento
          já existente.
        </BaSeHeading6>
        <br />
        <BaSeButton value="Fechar" onClick={handleCloseModal} />
      </ModalDefault>

      <div className="container">
        <div className="header-actions">
          {showMenu ? (
            <button
              type="button"
              className="hamburger"
              onClick={() => {
                toggleSideMenu();
                eventTag(event?.name, event?.category, event?.action, "Menu")
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21 16C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H21ZM21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H21ZM21 6C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H3C2.44772 8 2 7.55228 2 7C2 6.44772 2.44772 6 3 6H21Z"
                  fill="#2E5DE6"
                />
              </svg>
            </button>
          ) : (
            ""
          )}
          <Link to={!account ? '/' : '/planejadora'} className="logo" onClick={() => eventTag(event?.name, event?.category, event?.action, "Logo")}>
            <picture>
              <source media="(min-width: 1200px)" srcSet={logoInline} />
              <img src={logo} alt="Planejadora Sebrae" />
            </picture>
          </Link>
          {account ? (
            <>
              {showMenu ? (
                <div className="desktop">
                  <TemplateCompany />
                  <nav>
                    <ul>
                      {visibleMenuItems.map((item) => {
                        return (
                          <li
                            id={`${slugify(item?.name)}-driver-js`}
                            key={item.id}
                            className={pathname === item.path ? "active" : ""}
                          >
                            <Link
                              onClick={(e) => {
                                handleLinkClick(e, item.id)
                                eventTag(event?.name, event?.category, event?.action, item?.name)
                              }}
                              to={item.path}
                            >
                              {item?.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </nav>
                  <Solutions iconColor="#2E5DE6" />
                </div>
              ) : (
                ""
              )}
              <div className="notifications-profile">
                <Notifications />
                <div
                  id="info-driver-js"
                  className="icon-profile"
                  onClick={() => {
                    toggleMenuProfile()
                    eventTag(event?.name, event?.category, event?.action, "Menu Usuário")
                  }}
                >
                  <Acronyms avatar={account?.foto} nameUser={account?.name} />
                  <div
                    className={
                      "menu-profile-dropdown " +
                      (menuOpen.profile ? "opened" : "")
                    }
                  >
                    <TemplateMenuProfile />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <button
              type="button"
              className="btn-white-outline"
              onClick={() => {
                redirectToKeycloak()
                eventTag(event?.name, event?.category, event?.action, "Entrar")
              }}
            >
              <BaSeIcon
                color="#2E5DE6"
                description="user"
                name="user"
                size={14}
              />
              <span>Entrar</span>
            </button>
          )}
        </div>
      </div>
      {shouldRender.menu ? (
        <div className="side-menu">
          <div className="overlay" onClick={() => toggleSideMenu(false)}></div>
          <nav className={`${menuOpen.menu ? "slide-in" : "slide-out"}`}>
            <div className="nav-actions">
              <button
                type="button"
                className="hamburger"
                onClick={() => {
                  toggleSideMenu(false)
                  eventTag(event?.name, event?.category, event?.action, "Menu")
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21 16C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H21ZM21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H21ZM21 6C21.5523 6 22 6.44772 22 7C22 7.55228 21.5523 8 21 8H3C2.44772 8 2 7.55228 2 7C2 6.44772 2.44772 6 3 6H21Z"
                    fill="#2E5DE6"
                  />
                </svg>
              </button>
              <Link
                onClick={() => {
                  toggleSideMenu(false)
                  eventTag(event?.name, event?.category, event?.action, "Logo menu")
                }}
                to={!account ? '/' : '/planejadora'}
                className="logo"
              >
                <figure>
                  <img src={logoInline} alt="Planejadora Sebrae" />
                </figure>
              </Link>
              <button
                type="button"
                className="close"
                onClick={() => {
                  toggleSideMenu(false)
                  eventTag(event?.name, event?.category, event?.action, "Fechar menu")
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                >
                  <path
                    d="M10.6164 9.49994L14.0206 6.10369C14.331 5.79326 14.331 5.28996 14.0206 4.97953C13.7102 4.6691 13.2069 4.6691 12.8964 4.97953L9.5002 8.38369L6.10395 4.97953C5.79352 4.6691 5.29021 4.6691 4.97978 4.97953C4.66935 5.28996 4.66935 5.79326 4.97978 6.10369L8.38395 9.49994L4.97978 12.8962C4.82991 13.0448 4.74561 13.2472 4.74561 13.4583C4.74561 13.6694 4.82991 13.8717 4.97978 14.0204C5.12843 14.1702 5.33077 14.2545 5.54186 14.2545C5.75295 14.2545 5.9553 14.1702 6.10395 14.0204L9.5002 10.6162L12.8964 14.0204C13.0451 14.1702 13.2474 14.2545 13.4585 14.2545C13.6696 14.2545 13.872 14.1702 14.0206 14.0204C14.1705 13.8717 14.2548 13.6694 14.2548 13.4583C14.2548 13.2472 14.1705 13.0448 14.0206 12.8962L10.6164 9.49994Z"
                    fill="#005EB8"
                  />
                </svg>
              </button>
            </div>
            <div className="wrapper-items-mobile">
              <div className="aside-icon">
                <Solutions />
              </div>
              <div className="menu">
                <TemplateCompany />
                <ul>
                  {visibleMenuItems.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link
                          onClick={(e) => {
                            handleLinkClick(e, item.id)
                            eventTag(event?.name, event?.category, event?.action, item?.name)
                          }}
                          to={item.path}
                        >
                          <span>{item?.icon}</span>
                          <p>{item?.name}</p>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
                {/*<ul className="sub-menu">*/}
                {/*  {SubMenuItems.map((item) => {*/}
                {/*    return (*/}
                {/*      <li key={item.id}>*/}
                {/*        <a*/}
                {/*          onClick={() => toggleSideMenu(false)}*/}
                {/*          href={item.path}*/}
                {/*          target="_blank"*/}
                {/*          rel="noreferrer"*/}
                {/*        >*/}
                {/*          <p>{item?.name}</p>*/}
                {/*        </a>*/}
                {/*      </li>*/}
                {/*    );*/}
                {/*  })}*/}
                {/*</ul>*/}
              </div>
            </div>
          </nav>
        </div>
      ) : (
        ""
      )}
    </header>
  );
}
